<script>
import { Bar, mixins  } from 'vue-chartjs';

export default {
   extends: Bar,
    mixins: [mixins.reactiveProp],
    props: {
        chartData: {
            type: Object
        }        
    },
    data () {
        return {    
            options: {
                responsive: true,
                maintainAspectRatio: false   ,
                legend: {
                    //onClick: null,
                    labels: {fontColor:'white'},
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            suggestedMin: 0,
                            suggestedMax: 0,
                            fontColor: 'white',
                            // callback: function (value) {
                            // return (value / this.max * 100).toFixed(0) + '%'; // convert it to percentage
                            // },                            
                        },
                        scaleLabel: {
                            display: true,
                            labelString: 'days to trade',
                            fontColor: 'white',
                        }                            
                    }],
                    xAxes: [{
                        ticks: {
                            fontColor: 'white' 
                        }
                    }]                    
                }              
            }
        }
    },
   mounted() {
      this.renderChart(this.chartData, this.options)
   }
}

</script>